<template>
  <Form :label-width="80">
    <Card
      v-for="(item, index) in sourceList"
      :key="index"
      style="margin-bottom: 20px"
    >
      <p slot="title">
        <Icon type="ios-menu-outline"></Icon>
        仓库渠道{{ index + 1 }}
      </p>
      <div slot="extra">
        <Button type="text" @click="addSourceList">添加</Button>
        <Button
          v-if="sourceList.length > 1"
          type="text"
          @click="delSourceList(index)"
          >删除</Button
        >
      </div>
      <Row>
        <Col span="8">
          <FormItem label="省份">
            <Select
              v-model="item.areaCode"
              :label-in-value="true"
              style="width: 60%"
              @on-change="(value) => selectChange(value, index)"
            >
              <Option
                v-for="item in baseAreaAll || []"
                :key="item.code"
                :value="item.code"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="送达方编码">
            <Input
              v-model="item.shipToCode"
              placeholder="送达方编码"
              style="width: 60%"
            ></Input> </FormItem
        ></Col>
        <Col span="8">
          <FormItem label="渠道列表">
            <Select v-model="item.channelCodeList" multiple style="width: 60%">
              <Option
                v-for="item in baseChannelList"
                :value="item"
                :key="item"
                >{{ item }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Card>
    <Button type="primary" @click="add">{{
      mode === "edit" ? "修改" : "添加"
    }}</Button>
    <Button style="margin-left: 8px" @click="back">取消</Button>
  </Form>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      mode: "add",
      wmsCodeList: [],
      sourceList: [
        {
          areaCode: "",
          areaName: "",
          channelCodeList: [],
          shipToCode: "",
          wmsCode: "",
        },
      ],

      uploading: false,
    };
  },
  computed: {
    ...mapGetters({
      baseChannelList: "warehouse/getWmsBaseChannelList",
      baseAreaAll: "base/getBaseAreaAll",
    }),
  },
  watch: {},
  created() {
    // 区分模式
    this.sourceList[0].wmsCode = this.$route.query.code || "";
    this.$store
      .dispatch("base/getBaseAreaAll")
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });

    this.$store
      .dispatch("warehouse/getWmsBaseChannelList")
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    addSourceList() {
      this.sourceList.push({
        areaCode: "",
        areaName: "",
        channelCodeList: [],
        shipToCode: "",
        wmsCode: this.$route.query.code || "",
      });
    },
    delSourceList(index) {
      this.sourceList.splice(index, 1);
    },
    selectChange(value, sourceIndex) {
      this.$set(this.sourceList[sourceIndex], "areaCode", value.value || "");
      this.$set(this.sourceList[sourceIndex], "areaName", value.label || "");
    },
    // 添加
    add() {
      this.$store
        .dispatch("warehouse/wmsBatchUpdateChannel", this.sourceList)
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success("添加成功");
            setTimeout(this.back, 3000);
          } else {
            this.$Message.error(res.message || "添加失败，请稍后重试！");
          }
        })
        .catch((err) => {
          console.error(err);
          this.$Message.error(err);
        })
        .finally(this.$Spin.hide);
    },
    back() {
      this.$router.back();
    },
  },
};
</script>
<style scoped>
.card-title {
  display: flex;
  justify-content: space-between;
}

.card-title .index {
  flex: 1 1 auto;
}

.card-title .buttons {
  flex: 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/sourceEdit.vue